import { Card } from "@forge/common";
import totalCourses from '../../../../../common/assets/total-courses.svg';
import publishedCourses from '../../../../../common/assets/published-courses.svg';
import publishedCoursesDark from '../../../../../common/assets/published-dark.svg';
import draftDarkImg from '../../../../../common/assets/draft-dark.svg';
import totalCoursesDarkImg from '../../../../../common/assets/total-courses-dark.svg';
import courseInstanceDarkImg from '../../../../../common/assets/course-instance-dark.svg';
import courseInstanceImg from '../../../../../common/assets/course-instance.svg';
import draftImg from '../../../../../common/assets/draft.svg';
import "./view-course-count-card.scss";
import { getResponsiveFontSize, textResponsive } from "../../common/utils/helper";
import { VIEW_COURSE } from "../utils/constants";

const cardData = [
  {
    id: 2,
    title: "DRAFT",
    icon: draftImg,
    iconSelected: draftDarkImg,
  },
   {
    id: 1,
    title: "PUBLISHED",
    icon: publishedCourses,
    iconSelected: publishedCoursesDark,
  },
  {
    id: 0,
    title: "COURSE ENVIRONMENTS",
    icon: totalCourses,
    iconSelected: totalCoursesDarkImg,
  },
  {
    id: 3,
    title: "DEPLOYED COURSES",
    icon: courseInstanceImg,
    iconSelected: courseInstanceDarkImg,
  }
];

const ViewCourseCount = (props: any) => {
  const mergedCardData = cardData.map(card => {
    const countObj = props.cardCourseCountData?.find((c: any) => Number(c.id) === card.id);
    return {
      ...card,
      count: countObj ? countObj.count : 0,
    };
  });

  return (
    <div className="view-course-list py-1">
      <Card className="parent-card-course !p-4 !rounded-none w-full">
        <div className="card-row flex gap-4">
          {mergedCardData.map((card) => (
            <Card
              key={card.title}
              role="button"
              tabIndex={0}
              data-testid={`card-courses-${card.id}`}
              className={
                `card-courses` +
                (props.selectedCard === card.id ? " selected" : "") +
                " !h-[70px] xl-high:!h-[90px] !rounded-none shadow-none flex justify-between items-center !p-[14px] cursor-pointer flex-1 basis-0 min-w-0"
              }
              onClick={() => props.setSelectedCard(card?.id)}
            >
              <div>
                <div
                  className={
                    `count-courses` +
                    (props.selectedCard === card.id ? " selected" : "") +
                    ` ${getResponsiveFontSize(28)} font-bold leading-[36px] xl-high:mb-3`
                  }
                >
                  {card.count}
                </div>
                <div
                  className={
                    `count-courses-title` +
                    (props.selectedCard === card.id ? " selected" : "") +
                    ` ${textResponsive("text-xs")} font-medium leading-[20px] uppercase`
                  }
                >
                  {card.title}
                </div>
              </div>
              <img
                src={props.selectedCard === card.id ? card.iconSelected : card.icon}
                alt="Course Icon"
                className="course-icon"
              />
            </Card>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default ViewCourseCount;